function useCalendarPayload(vm) {
    const states = { ...vm.$store.state.calendar };
    const { calendarSettings, periods } = states;
    const grouped = {};

    (periods.periodList ?? []).forEach((period) => {
        const key = period.originalId || period.id;
        if (!grouped[key]) {
            grouped[key] = [];
        }
        grouped[key].push(period);
    });

    const mergedPeriods = Object.values(grouped).map((group) => {
        const sortedGroup = group.sort(
            (a, b) => new Date(a.originalStartTime) - new Date(b.originalStartTime)
        );

        const referenceDate = new Date(calendarSettings.generalApplied.referenceDate);

        const formatDateTime = (dayOffset, timeString) => {
            const date = new Date(referenceDate);
            date.setDate(date.getDate() + (dayOffset - 1)); // dia 1 = referenceDate
            const [hours, minutes, seconds] = timeString.split(":");
            date.setHours(hours, minutes, seconds || 0, 0);
            return date;
        };

        const adjustTimeZone3 = (date) => {
            const offset = date.getTimezoneOffset() * 60000;
            const localISOTime = new Date(date.getTime() - offset).toISOString().slice(0, -1);
            return localISOTime;
        };

        const isNextDay = (startTime, endTime, isSameDay) => {
            if (isSameDay === true) return false;

            const start = new Date(startTime);
            const end = new Date(endTime);

            start.setHours(0, 0, 0, 0);
            end.setHours(0, 0, 0, 0);

            const diffInMs = end - start;
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            return diffInDays === 1;
        };

        if (sortedGroup.length === 1) {
            const period = sortedGroup[0];
            const startDate = period.originalStartTime ?? period.shift.startTime;
            const endDate = period.originalEndTime ?? period.shift.endTime;
            const originalStart = new Date(startDate).toTimeString().split(" ")[0];
            const originalEnd = new Date(endDate).toTimeString().split(" ")[0];

            const startTime = adjustTimeZone3(formatDateTime(period.day, originalStart));
            const endTime = adjustTimeZone3(formatDateTime(period.day, originalEnd));

            return {
                id: period.originalId ?? period.id,
                day: period.day,
                shift: {
                    shiftClassificationId: period.shiftId ?? null,
                    startTime,
                    endTime,
                    nextDay: isNextDay(startDate, endDate, period.isSameDay)
                },
                efficiency: period.efficiency,
                startTime: period.startTime,
                endTime: period.endTime
            };
        } else {
            const sortedList = sortedGroup.sort((a, b) => a.day - b.day);
            const first = sortedList[0];
            const last = sortedList[sortedList.length - 1];

            const originalStart = new Date(first.originalStartTime).toTimeString().split(" ")[0];
            const originalEnd = new Date(last.originalEndTime).toTimeString().split(" ")[0];

            const startTime = adjustTimeZone3(formatDateTime(first.day, originalStart));
            const endTime = adjustTimeZone3(formatDateTime(last.day, originalEnd));

            return {
                id: first.originalId,
                day: first.day,
                shift: {
                    shiftClassificationId: first.shiftId ?? null,
                    startTime,
                    endTime,
                    nextDay: true
                },
                efficiency: first.efficiency,
                startTime: first.startTime,
                endTime: last.endTime
            };
        }
    });

    const payload = {
        name: calendarSettings.generalApplied.name,
        referenceDate: calendarSettings.generalApplied.referenceDate,
        duration: Number(calendarSettings.generalApplied.duration),
        events:
            calendarSettings.events.eventList?.map((event) => {
                const { id, origin, ...restOfEvent } = event;

                return {
                    ...restOfEvent,
                    id: origin === "front" ? null : id
                };
            }) ?? [],
        resources: calendarSettings.resources.resourcesList?.map((resource) => resource.id) ?? [],
        periods: mergedPeriods
    };

    return { payload };
}

export default useCalendarPayload;
